// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    GridToolbarContainer, GridToolbarExport, useGridApiRef
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PolylineIcon from '@mui/icons-material/Polyline';
import ShareIcon from '@mui/icons-material/Share';
import Button from "@mui/material/Button";
import {
    Avatar,
    darken,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, lighten,
    ListItemIcon, ListItemText, Stack,
    Tooltip
} from "@mui/material";
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import ListIcon from '@mui/icons-material/List';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// App Imports
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import {DataGridPro} from "@mui/x-data-grid-pro";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {changeContractSection} from "../../ContractSection/contractSectionSlice";
import {
    deleteContractSection, deleteMasterContractSection, getContractCS, moveContractSection, populateDashboard,
    regrowBranch,
    reinsertBranch,
    repeatBranch, repeatBranchFresh, trimBranch, updateCsTreeByContractId
} from "../../ContractSection/ContractSectionClient";
import ContractSectionDrawer from "../../ContractSection/ContractSectionDrawer";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ContractSectionCloningForm from "../../ContractSection/ContractSectionCloningForm";
import Typography from "@mui/material/Typography";
import {changeContract} from "../../Contract/contractSlice";
import {changeContractDrilldown} from "../contractDrilldownSlice";
import {changeContractDrilldownCS} from "./contractDrilldownSliceCS";
import {changeWork} from "../../Work/workSlice";
import {AccountTree, ContentCut} from "@mui/icons-material";
import CsfInfoDialogue from "../ContractDrilldownCSF/Info/CsfInfoDialogue";
import CsInfoDialogue from "./Info/CsInfoDialogue";
import QueryFinancialsDropdownVersion from "./Helpers/LineItems/QueryFinancialsDropdownVersion";
import {changeContractDrilldownCDP} from "../ContractDrilldownCDP/contractDrilldownSliceCDP";
import QueryFinancialsDrawer from "./Helpers/LineItems/QueryFinancialsDrawer";
import HelpIcon from "@mui/icons-material/Help";
import {changeHelper} from "./Helpers/helperSlice";
import ContractSectionGraftingForm from "../../ContractSection/ContractSectionGraftingForm";


// main function
export default function ContractDrilldownCSGrid(props) {

    // ****************** BEGIN STATES ****************************

    // grid data states
    const [drilldownCS, setDrilldownCS] = useState([]);
    const [allCS, setAllCS] = useState([]);
    const [filteredCS, setFilteredCS] = useState([]);

    const [csInfoOpen, setCsInfoOpen] = useState(false);

    // grid behavior states
    const [showControls, setShowControls] = useState(true);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [financialQueryOpen, setFinancialQueryOpen] = React.useState(false);


    // drawer behavior states
    const [contractSectionDrawerMode, setContractSectionDrawerMode] = React.useState([]);
    const [contractSectionDrawerState, setContractSectionDrawerState] = React.useState(false);
    const [treeDepth, setTreeDepth] = React.useState(0);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const expandContractSectionId = useSelector((state) => state.contractDrilldownSlcExpandCS.value.contractSectionId);
    const expandParent1Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent1Id);
    const expandParent2Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent2Id);
    const expandParent3Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent3Id);
    const expandParent4Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent4Id);
    const expandParent5Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent5Id);
    const expandParent6Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent6Id);
    const expandParent7Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent7Id);
    const expandParent8Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent8Id);
    const expandParent9Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent9Id);
    const expandParent10Id = useSelector((state) => state.contractDrilldownSlcExpandCS.value.parent10Id);

    const selectorContractId = useSelector((state) => state.contractSlc.value.id);
    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);
    const selectorParentSectionId = useSelector((state) => state.contractSectionSlc.value.parentSectionId);
    const mousedContractId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedContractId);
    const mousedContractSectionId = useSelector((state) => state.contractDrilldownSlcCS.value.mousedId);
    const mousedContractSectionName = useSelector((state) => state.contractDrilldownSlcCS.value.mousedName);
    const selectorContractSectionNameShort = useSelector((state) => state.contractSectionSlc.value.nameShort);

    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const hideActions = localStorage.getItem('hideActions') === "true";


    // ****************** BEGIN FETCH ****************************

    // const fetchDrilldownCS = () =>
    //         console.log("fetching contract sections using fetchDrilldownCS");
    //         console.log("selectorContractId on contract grid, ", selectorContractId);
    //     getContractCS(selectorContractId)

    //         .then(data => {
    //             console.log(data);
    //             setDrilldownCS(data);
    //             setAllCS(data);
    //             setFilteredCS(data);
    //             console.log("this is my filtered sections data");
    //             console.log(filteredCS);
    //         });
    const fetchDrilldownCS = () => {
        console.log("fetching contract sections using fetchDrilldownCS");
        console.log("selectorContractId on contract grid,", selectorContractId);

        getContractCS(selectorContractId)

            .then(data => {
                setDrilldownCS(data);
                setAllCS(data);
                setFilteredCS(data);
                console.log("cs data");
                console.log(data);
                // console.log(labelValue); // "test 123"
            })
            .catch(err => console.error("getContractCS failed:", err));
    };


    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************
    //
    // useEffect(() => {
    //     console.log("This is working so far...");
    //     fetchDrilldownCS();
    // }, [useSelector((state) => state.contractSlc.value.id)]);
    //
    //
    // useEffect(() => {
    //     console.log("Contract fetch triggered by updating contract id");
    //     fetchDrilldownCS();
    // }, [selectorContractId]);

    //
    // useEffect(() => {
    //     fetchDrilldownCS();
    //     dispatchData(changeContractSection({csGridRefresh: false}));
    // }, [useSelector((state) => state.contractSectionSlc.value.csGridRefresh)===true]);


    useEffect(() => {
        fetchDrilldownCS();
        console.log("fetching cs drilldown triggered by csGridRefresh");
        dispatchData(changeContractSection({csGridRefresh: false}));

    }, [useSelector((state) => state.contractSectionSlc.value.csGridRefresh)===true]);

    // ******************** END USE EFFECTS *******************


    // **************************************** expand **************************************************************************

    const apiRef = useGridApiRef();

    // State to manage expanded nodes
    const [expandedNodes, setExpandedNodes] = React.useState({});


        const expandNodeByFieldValue = () => {

            if (expandContractSectionId !== undefined && expandContractSectionId !== null) {
                console.log("Attempting to expand node with this contract section id:", expandContractSectionId);
                console.log("Parent Section 1:", expandParent1Id);
                console.log("Parent Section 2:", expandParent2Id);
                // Find the node based on the hierarchy field value
                const node = filteredCS.find(row => row.id === expandContractSectionId.split(',')[0]);
                const node1 = filteredCS.find(row => row.id === expandContractSectionId);
                if (expandParent10Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent10Id, true);
                }
                ;
                if (expandParent9Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent9Id, true);
                }
                ;
                if (expandParent8Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent8Id, true);
                }
                ;
                if (expandParent7Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent7Id, true);
                }
                ;
                if (expandParent6Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent6Id, true);
                }
                ;
                if (expandParent5Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent5Id, true);
                }
                ;
                if (expandParent4Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent4Id, true);
                }
                ;
                if (expandParent3Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent3Id, true);
                }
                ;
                if (expandParent2Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent2Id, true);
                }
                ;
                if (expandParent1Id) {
                    apiRef.current.setRowChildrenExpansion(expandParent1Id, true);
                }
                ;
            }
        };
// apiRef.current

    useEffect(() => {
        const timeout = setTimeout(() => {
        expandNodeByFieldValue();
        // dispatchData(changeContractDrilldownExpandCS({csExpand: false}));
        }, 2000);
}, [useSelector((state) => state.contractDrilldownSlcExpandCS.value.csExpand)===true]);

        const openNewWindow = (nodeHierarchy) => {
            const newWindow = window.open('http://localhost:3000/ResidualsFrontend', '_blank');
            const dataToSend = { type: 'UPDATE_DATA', payload: { contractId: '2', cdpId: '12345' } };
            // Log before sending data
            console.log('Preparing to send data:', dataToSend);

            // Send the data after a short delay
            setTimeout(() => {
                if (newWindow) {
console.log("new window path at message time: ", newWindow.location.pathname)
                    newWindow.onload = () => {
                    newWindow.postMessage(dataToSend, 'http://localhost:3000'); // Ensure this matches your new window's origin
                    console.log('Data successfully sent to the new window:', dataToSend);
                }} else {
                    console.error('Failed to open the new window or newWindow is null.');
                };
            }, 500);
        }

    useEffect(() => {
        // Define the message event listener
        const handleMessage = (event) => {
            // Ensure the message is from a trusted origin
            // if (event.origin !== 'http://localhost:3000') return; // Replace with your main app's origin
            dispatchData(changeContract({contractDrilldownVisible: true,contractGridVisible: true}));
            console.log("I just got a message top part");
            // Add the event listener for messages
            window.addEventListener('message', handleMessage);

            // Dispatch the received data to the Redux store
            if (event.data && event.data.type === 'UPDATE_DATA') {
                // dispatch(updateData(event.data.payload));
                dispatchData(changeContract({contractDrilldownVisible: true}));
                console.log("I just got a message bottom part");
            }
        };

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    // **************************************** end expand **************************************************************************


    // ***************** BEGIN CONTROLS ***************************

    const handleExplore = (drilldownCSId, rowElement, rowFull) => {
        dispatchData(changeContractSection({id: drilldownCSId}));
        dispatchData(changeContractDataPoint({contractSectionId: drilldownCSId}));
        console.log("This is what was received");
        console.log(drilldownCSId);
        console.log("This is the contract section chosen");
        console.log(selectorContractSectionId);
    }

    const handleAdd = () => {
        console.log("HandleAdd triggered.");
        dispatchData(changeContractDrilldownCS({
            mousedId: null,
            // MousedContractId: Number(selectorContractId),
            mousedMcode: null,
            mousedName: null,
            mousedDescription: null,
            mousedParentSectionId: null,
            mousedPreviousSectionId: null,
            mousedHierarchy: null,
            mousedRecordLevel: null,
            mousedOrdinalNumber: null,
            mousedStatus: null,
            mousedCreatedOn: null,
            mousedCreatedBy: null,
            mousedLastModifiedOn: null,
            mousedLastModifiedBy: null,
        mousedType: null,}));
        dispatchData(changeContractSection({csDrawerState: true, csDrawerMode: "Add", type: null }));
    };

    const handleEdit = (editData) => {
        console.log("HandleEdit triggered.");
        dispatchData(changeContractSection({
            csDrawerState: true, csDrawerMode: "Edit"}));
    }


    const handlePivot = (editData) => {
        console.log("HandleEdit triggered.");
        dispatchData(changeWork({
            dashboardPivotState: true}));
    }


    const removeContractSection = (mousedContractSectionId, callback) => {
        deleteContractSection(mousedContractSectionId)
            .then(() => {
            console.log("Contract section deleted successfully.");
            setDeleteOpen(false);
            fetchDrilldownCS();
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
            .catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Deletion failed"}));
            })
    }

        const handleDeleteOpen = () => {
        setDeleteOpen(true);
        return(
            <Dialog
                open={deleteOpen}
                onClose={handleDeleteClose}
                aria-labelledby="alert-delete-dialog-title"
                aria-describedby="alert-delete-dialog-description"
            >
                <DialogTitle id="alert-delete-dialog-title">
                    {"Delete Confirmation"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-delete-dialog-description">
                        You are about to delete contract section {mousedContractSectionId},
                        {mousedContractSectionName}.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel}>Cancel</Button>
                    <Button onClick={() => removeContractSection(mousedContractSectionId)} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

        )
    };


    function handleMousedRow(data) {
        console.log('moused row');
        console.log(data);
        dispatchData(changeContractDrilldownCS({
            mousedId: data.id,
            mousedContractId: data.contractId,
            mousedParentSectionId: data.parentSectionId,
            mousedParentOrdinalNumber: data.parentOrdinalNumber,
            mousedParentRecordLevel: data.parentRecordLevel,
            mousedParentMcode: data.parentMcode,
            mousedParentName: data.parentName,
            mousedParentDescription: data.parentDescription,
            mousedPreviousSectionId: data.previousSectionId,
            mousedPreviousOrdinalNumber: data.previousOrdinalNumber,
            mousedPreviousRecordLevel: data.previousRecordLevel,
            mousedPreviousMcode: data.previousMcode,
            mousedPreviousName: data.previousName,
            mousedPreviousDescription: data.previousDescription,
            mousedOrdinalNumber: data.ordinalNumber,
            mousedRecordLevel: data.recordLevel,
            mousedMcode: data.mcode,
            mousedName: data.name,
            mousedDescription: data.description,
            mousedStatus: data.status,
            mousedHierarchy: data.hierarchy,
            mousedType: data.type,
            mousedContents: data.contents,
            mousedCreatedOn: data.createdOn,
            mousedCreatedBy: data.createdBy,
            mousedLastModifiedOn: data.lastModifiedOn,
            mousedLastModifiedBy: data.lastModifiedBy}));
        dispatchData(changeWork({selectedDashboardSectionId:data.id }));
        console.log("slice parent");
        console.log(selectorParentSectionId);
    }


    const handleClickedRow = (data) => {
        console.log('clicked row');
        console.log(data);

        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4634) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Account: Mapped Prod"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4635) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Account: Other"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4660) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Account: Residuals"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4636) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Account: Mapped Dist"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4301) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Line Item"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && (data.type === 4331 || data.type === 4332)) {
            dispatchData(changeContractDrilldown({helperState: false,dynamicHelperState: true, helperMode: null}));
        }

        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4454) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Summary Item"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4301) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Line Item"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4584) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Cost Item"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4302) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Participant Gross Share"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4455) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Participant Net Share"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4367) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Adjusted Gross Receipts"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4368) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Gross Receipts"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4369) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Allowed Expenses"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4370) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Overall Share"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4525) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Distribution Fee"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4527) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Overhead Fee"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4589) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Overhead Fee - Expense"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4590) {
            dispatchData(changeContractDrilldown({helperState: false,dynamicHelperState: true, helperMode: "Overhead Fee - Cost"}));
        }
        if((selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") && data.type === 4305) {
            dispatchData(changeContractDrilldown({helperState: true,dynamicHelperState: false, helperMode: "Bonus"}));
        }
        if((selectorContractGridAPI !== "PartsAbstracts" && selectorContractGridAPI !== "PartsStandards") || (
            data.type !== 4634 &&
            data.type !== 4635 &&
            data.type !== 4660 &&
            data.type !== 4636 &&
            data.type !== 4331 &&
            data.type !== 4301 &&
            data.type !== 4584 &&
            data.type !== 4302 &&
            data.type !== 4455 &&
            data.type !== 4367 &&
            data.type !== 4368 &&
            data.type !== 4369 &&
            data.type !== 4370 &&
            data.type !== 4332 &&
            data.type !== 4454 &&
            data.type !== 4525 &&
                data.type !== 4305 &&
            data.type !== 4527
            )) {
            dispatchData(changeContractDrilldown({helperState: false,dynamicHelperState: false, helperMode: null}));
        }
        dispatchData(changeContractSection({id: data.id, contractId: data.contractId,
            parentSectionId: data.parentSectionId, parentOrdinalNumber: data.parentOrdinalNumber,
            parentRecordLevel: data.parentRecordLevel, parentMcode: data.parentMcode,
            parentName: data.parentName, parentDescription: data.parentDescription,
            previousSectionId: data.previousSectionId, previousOrdinalNumber: data.previousOrdinalNumber,
            previousRecordLevel: data.previousRecordLevel, previousMcode: data.previousMcode,
            previousName: data.previousName, previousDescription: data.previousDescription,
            ordinalNumber: data.ordinalNumber, recordLevel: data.recordLevel,
            mcode: data.mcode, name: data.name, description: data.description,
            status: data.status, hierarchy: data.hierarchy, type: data.type, contents: data.contents,
            createdOn: data.createdOn, createdBy: data.createdBy,
            lastModifiedOn: data.lastModifiedOn,
            lastModifiedBy: data.lastModifiedBy,
            nameShort: data.name.substring(0,70)
        }));
        const selectorRawContents = data.contents;

        const selectorContents =
            typeof selectorRawContents === "string"
                ? JSON.parse(selectorRawContents)
                : selectorRawContents;
        console.log("selector contents (json blob in Helper");
        console.log(selectorContents);
        console.log("data =", data);
        console.log("data.contents =", data.contents);
        console.log("typeof data.contents =", typeof data.contents);

        const label = [
            "12413",
            "12574",
            "12029",
            // "12100",
            // "12361",
            // "12107",
            "11790",
            "11622",
            // "12106",
            "12369",
            // "12427",
            "12110",
            "12417",
            "11936",
            // "11990",
            // "12405",
            "11926"
        ]
            .map(id => selectorContents?.[id] ?? "")
            .join("");
        dispatchData(changeHelper({
            // label: selectorContents?.["12029"],

            label: label,
            // label:
            //     selectorContents?.["12413"] ||
            //     selectorContents?.["12574"] ||
            //     selectorContents?.["12029"] ||
            //     selectorContents?.["12100"] ||
            //
            //     selectorContents?.["12361"] ||
            //     selectorContents?.["12107"] ||
            //     selectorContents?.["11790"] ||
            //     selectorContents?.["11622"] ||
            //
            //     selectorContents?.["12106"] ||
            //     selectorContents?.["12369"] ||
            //
            //     selectorContents?.["12427"] ||
            //     selectorContents?.["12110"] ||
            //     selectorContents?.["12417"] ||
            // selectorContents?.["11936"] ||
            //     selectorContents?.["11990"] ||
            //     selectorContents?.["12405"] ||
            // selectorContents?.["11926"]  ,


            share: selectorContents?.["11929"],
            netShare: selectorContents?.["3664"],
            royalty: selectorContents?.["12018"],
            min: selectorContents?.["12056"],
            max: selectorContents?.["12015"],
            fromAmount: selectorContents?.["12411"],
            toAmount: selectorContents?.["12412"],
            dateFrom: selectorContents?.["12071"],
            dateTo: selectorContents?.["12072"],
            accountAction: selectorContents?.["12074"],
            marketAction: selectorContents?.["12077"],
            distributionChannelAction: selectorContents?.["12080"],
            regionAction: selectorContents?.["12083"],
            countryAction: selectorContents?.["12086"],
            languageAction: selectorContents?.["12089"],
            summaryExpression: selectorContents?.["12401"],
            sumSign: selectorContents?.["12476"],
            distributionFee: selectorContents?.["12597"],
            overheadFee: selectorContents?.["12598"],
            distFeePct: selectorContents?.["3561"],
            overheadFeePct: selectorContents?.["11644"],

            maxNet: selectorContents?.["12602"],
            maxShare: selectorContents?.["12603"],
            maxGross: selectorContents?.["12604"],
            grossesMapping: selectorContents?.["12595"],
            expensesMapping: selectorContents?.["12596"],
            adjGrossMapping: selectorContents?.["12599"],
            bonusMapping: selectorContents?.["12610"],

            maxFee: selectorContents?.["12600"],
            maxAmount: selectorContents?.["12623"],
            resultLimiter:
                selectorContents?.["12624"]
                    ?.split(" + ")
                    .map(value => value.trim())
                    .filter(Boolean) ?? []
            ,
            maxResultPct: selectorContents?.["12625"],


            maxBasis: selectorContents?.["12601"],
            basisLimiter:
                selectorContents?.["12626"]
                    ?.split(" + ")
                    .map(value => value.trim())
                    .filter(Boolean) ?? []
            ,
            maxBasisPct: selectorContents?.["12627"],

            overheadSubToMax: selectorContents?.["12628"],
            overheadMaxFee: selectorContents?.["12629"],
            overheadMaxBasis: selectorContents?.["12630"],
            overheadMaxFeeLimiter:
                selectorContents?.["12631"]
                    ?.split(" + ")
                    .map(value => value.trim())
                    .filter(Boolean) ?? []
            ,
            overheadMaxFeePct: selectorContents?.["12632"],
            overheadMaxBasisLimiter:
                selectorContents?.["12633"]
                    ?.split(" + ")
                    .map(value => value.trim())
                    .filter(Boolean) ?? []
            ,
            overheadMaxBasisPct: selectorContents?.["12634"],


            distributionFeeMulti:
                selectorContents?.["12597"]
                    ?.split(" + ")
                    .map(value => value.trim())
                    .filter(Boolean) ?? []
           ,
        overheadFeeMulti:
            selectorContents?.["12598"]
                ?.split(" + ")
                .map(value => value.trim())
                .filter(Boolean) ?? []
    }));
        // dispatchData(changeContractDrilldown({helperState: false}));
    }

const handleHelperPanel = () => {
    dispatchData(changeContractDrilldown({helperState: true}));
}

    const handleDynamicHelperPanel = () => {
        dispatchData(changeContractDrilldown({dynamicHelperState: true}));
    }


    const handleCsInfo = () => {
        setCsInfoOpen(true);
    };

    const handleCloseCsInfo = () => {
        setCsInfoOpen(false);
    };

    //
    // const handleDeleteClose = () => {
    //     setDeleteOpen(false);
    // };
    //
    // const handleDeleteCancel = () => {
    //     setDeleteOpen(false);
    // };

    const maxFinalByPrefix = filteredCS.reduce((acc, row) => {
        const parts = row.hierarchy?.split(',') ?? [];
        const finalNumber = Number(parts[parts.length - 1]);
        const prefix = parts.slice(0, -1).join(',');

        acc[prefix] = Math.max(acc[prefix] ?? 0, finalNumber);

        return acc;
    }, {});

    const handleAddBranch = (row) => {
        if(selectorContractGridAPI === "PartsAbstracts") {
        console.log("repeating this branch fresh (from standard contract): ", row.id)
        repeatBranchFresh(row.id).then(() => {
            dispatchData(changeContractSection({csGridRefresh: true}));
        })}
        if(selectorContractGridAPI === "PartsStandards") {
            console.log("repeating this branch: ", row.id)
            repeatBranch(row.id).then(() => {
                dispatchData(changeContractSection({csGridRefresh: true}));
            })}
    };



    function BoldAfterHyphen({ text }) {
        const index = text.indexOf("-");

        if (index === -1) {
            return <>{text}</>;
        }

        return (
            <>
                {text.substring(0, index + 1)}
                <strong>{text.substring(index + 1)}</strong>
            </>
        );
    }


    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchDrilldownCS => [

        {
            field: "contractExplore",
            headerName: '',
            width: 30,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: true,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <InfoOutlinedIcon onClick= {() => handleExplore(drilldownCS.row.id, drilldownCS.row.name, drilldownCS.row)}/>
                    </IconButton>
                );
            }
        },
        {
            field: "more",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: hideActions,
            renderCell: (filteredCS) => {
                return (<div onMouseOver = {() => handleMousedRow(filteredCS.row)}  >
                    <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={`Click to see actions for record ${filteredCS.row.id}`}
                    >
                        <CsGridCrudMenu />
                    </Tooltip>
                    </div>
                );
            }
        },
        {
            field: 'VersionCount',
            headerName: 'Versions',
            width: 30,
            sortable: false,
            // renderCell: (contracts) => <AbstractStatusMenu rowContractData={contracts.row} />,
            hide: selectorContractGridAPI !== "Dashboards",
            renderCell: (filteredCS) => {
                if (filteredCS.row.versionCount > 0 ) {
                    // if ((rowContractData.status === 'Unapproved' || rowContractData.status === 'NEW')  && rowContractData.mcode === 'Guild'  && rowContractData.missingInputCount > 0 ) {
                    return (
                        <div>
                            <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={"Count of dashboard versions generated"}>
                                <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: 'black'}}
                                        onClick={() => handlePivot()}
                                >{filteredCS.row.versionCount}</Avatar>
                            </Tooltip>
                        </div>)}
                else {
                    return (<div/>)
                }
            }
        },
        {
            field: 'missingInputCount',
            headerName: 'Missing',
            width: 30,
            sortable: false,
            // renderCell: (contracts) => <AbstractStatusMenu rowContractData={contracts.row} />,
            hide: (selectorContractGridAPI !== "PartsAbstracts" && selectorContractGridAPI !== "RoyalAbstracts"),
            renderCell: (filteredCS) => {
                if (filteredCS.row.versionCount > 0 ) {
                    // if ((rowContractData.status === 'Unapproved' || rowContractData.status === 'NEW')  && rowContractData.mcode === 'Guild'  && rowContractData.missingInputCount > 0 ) {
                    return (
                        <div>
                            <Tooltip   enterDelay={1000}  enterNextDelay={1000} title={"This section has missing input values"}>
                                <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: 'black'}}>{filteredCS.row.versionCount}</Avatar>
                            </Tooltip>
                        </div>)}
                    if (filteredCS.row.missingIndicator === 'missing'  && filteredCS.row.missingInputCount > 0 ) {
                    // if ((rowContractData.status === 'Unapproved' || rowContractData.status === 'NEW')  && rowContractData.mcode === 'Guild'  && rowContractData.missingInputCount > 0 ) {
                    return (
                    <div>
                        <Tooltip   enterDelay={1000}  enterNextDelay={1000} title={"This section has missing input values"}>
                    <Avatar sx={{height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>{filteredCS.row.missingInputCount}</Avatar>
                        </Tooltip>
            </div>)}
                if (filteredCS.row.missingIndicator === 'missing'  && filteredCS.row.missingInputCount < 1 ) {
                    // if ((rowContractData.status === 'Unapproved' || rowContractData.status === 'NEW')  && rowContractData.mcode === 'Guild'  && rowContractData.missingInputCount > 0 ) {
                    return (
                        <div>
                            <Tooltip   enterDelay={1000}  enterNextDelay={1000} title={"A sub-section has missing input values"}>
                            <Avatar sx={{height: 20, width: 20, fontSize: 14,  color: '#d50000',fontColor: '#d50000',  bgcolor: '#d50000'}}>_</Avatar>
                            </Tooltip>
                        </div>)}
                else {
                    return (<div/>)
                }
            }
        },
        {
            field: "cSEdit",
            headerName: '',
            onCellClick: {},
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <EditIcon fontSize={'small'}  onClick= {() => handleEdit(
                            drilldownCS.row)}/>
                    </IconButton>

                );
            }
        },
        {
            field: "cSDelete",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (filteredCS) =>
                <IconButton
                    size="small"
                    variant="contained"
                    color="primary"
                >
                    <DeleteOutlineIcon fontSize={'small'} onClick= {() => handleDeleteOpen()}/>

                </IconButton>

        },
        {
            field: "up",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <ArrowDropUpIcon/>
                    </IconButton>
                )
            }
        },
        {
            field: "down",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <ArrowDropDownIcon/>
                    </IconButton>
                );
            }
        },
        {
            field: "left",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <ArrowLeftIcon/>
                    </IconButton>
                );
            }
        },
        {
            field: "right",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <ArrowRightIcon/>
                    </IconButton>
                );
            }
        },
        {    field: 'contractId',
            headerName: 'cid',
            description: 'This is the contract to which the sections belong.',
            sortable: false,
            width: 60,
            hide: true,
        },
        {    field: 'id',
            headerName: 'id',
            description: 'This id is auto-assigned and has no meaning.',
            sortable: false,
            width: 60,
            hide: true,
        },
        {
            field: 'parentSectionId',
            // propertyId: 'contract_id',
            headerName: 'Parent',
            description: '',
            sortable: true,
            // editable: true,
            width: 100,
            hide: true,
        },
        {
            field: 'previousSectionId',
            // propertyId: 'contract_id',
            headerName: 'Previous',
            description: '',
            sortable: true,
            // editable: true,
            width: 100,
            hide: true,
        },
        {    field: 'ordinalNumber',
            headerName: '#',
            description: 'This is the order the sections appear in the agreement.',
            sortable: false,
            width: 60,
            hide: true,
        },
        {
            field: 'recordLevel',
            headerName: 'Level',
            description: 'This is how deeply nested the section is - chapter, sub-chapter, etc..',
            sortable: false,

            width: 60,
            hide: true,
        },
        {
            field: 'name',
            headerName: 'Name',
            description: 'This is the name of the section.',
            sortable: false,
            editable: false,
            width: 500,

            renderCell: (params) => {

                const parts = params.row.hierarchy?.split(',') ?? [];
                const finalNumber = Number(parts[parts.length - 1]);
                const prefix = parts.slice(0, -1).join(',');

                const isLastSibling =
                    finalNumber === maxFinalByPrefix[prefix];

                const showAdd =
                    (selectorContractGridAPI === "PartsAbstracts" || selectorContractGridAPI === "PartsStandards") &&
                    [4634, 4635, 4636, 4301, 4584, 4302, 4303, 4304, 4332, 4454, 4455, 4525, 4527, 4660].includes(params.row.type) && isLastSibling;

                const name = params.row.name ?? "";
                // const index = name.indexOf("-");
                const hyphenIndex = name.indexOf("-");
                const accountIndex = name.indexOf("Account: ");

                const index =
                    accountIndex !== -1
                        ? accountIndex + "Account: ".length - 1
                        : hyphenIndex;
                const recordLevel = params.row.recordLevel ?? "";


                return (
                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                    >



                        <Tooltip
                            placement="left-end"
                            enterDelay={1000}
                            enterNextDelay={1000}
                            title={
                                <span style={{ whiteSpace: 'pre-line' }}>
                            {"name: " + params.row.name +
                                "\ndescription: " + params.row.description +
                                "\nid: " + params.row.id +
                                "\norder: " + params.row.ordinalNumber +
                                "\nparent: " + params.row.parentSectionId +
                                "\nprevious: " + params.row.previousSectionId +
                                "\nfilters: " + params.row.csfCount +
                                "\ndata points: " + params.row.cdpCount}
                        </span>
                            }
                        >
                            <p
                                onClick={() => handleClickedRow(params.row)}
                                style={{
                                    cursor: 'pointer',
                                    margin: 0,
                                    textDecoration:
                                        params.row.id === selectorContractSectionId
                                            ? 'underline'
                                            : 'none',
                                    backgroundColor:
                                        params.row.id === expandContractSectionId
                                            ? 'yellow'
                                            : 'transparent',
                                }}
                            >
                                {(index === -1 || recordLevel === 1 || (selectorContractGridAPI !== 'PartsAbstracts' && selectorContractGridAPI !== 'PartsStandards')) ? (
                                    name
                                ) : (
                                    <>
                                        {name.substring(0, index + 1)}
                                        <strong>{name.substring(index + 1)}</strong>
                                    </>
                                )}
                                {/*{params.row.name}*/}
                            </p>
                        </Tooltip>
                        {showAdd && (
                            <Button
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleAddBranch(params.row);
                                }}
                            >
                                Add
                            </Button>
                        )}
                    </Stack>

                );
            }
        },
        // {field: 'add',
        //     headerName: '',
        //     description: 'Add a branch here',
        //     sortable: false,
        //     disabled: true,
        //     editable: true,
        //     width: selectorContractGridAPI === "PartsAbstracts" && (filteredCS.row.type === 4301 || filteredCS.row.type === 4332) ? 60 : 0,
        //     cursor: "pointer",
        //
        //     renderCell: (filteredCS) => {
        //         // return (
        //         if(selectorContractGridAPI === "PartsAbstracts" && (filteredCS.row.type === 4301 || filteredCS.row.type === 4332)) {
        //             return (
        //                 <Button>Add</Button>
        //             )
        //         }
        //
        //     }},
        // {
        //     field: 'name',
        //     headerName: 'Name',
        //     description: 'This is the name of the section.',
        //     sortable: false,
        //     disabled: true,
        //     editable: false,
        //     width: 500,
        //     cursor: "pointer",
        //
        //     renderCell: (filteredCS) => {
        //         return (
        //             <Tooltip  placement={'left-end'}  enterDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
        //             {"name: " + filteredCS.row.name +
        //                 "\ndescription: " + filteredCS.row.description +
        //                 "\nid: " + filteredCS.row.id +
        //                 "\norder: " + filteredCS.row.ordinalNumber +
        //                 "\nparent: " + filteredCS.row.parentSectionId +
        //                 "\nprevious: " + filteredCS.row.previousSectionId +
        //                 "\nfilters: " + filteredCS.row.csfCount +
        //                 "\ndata points: " + filteredCS.row.cdpCount
        //             }</span>}>
        //     <p onClick= {() => handleClickedRow(filteredCS.row)
        //     } style={{cursor:'pointer',
        //         textDecoration: filteredCS.row.id === selectorContractSectionId ? 'underline' : 'none',
        //         backgroundColor: filteredCS.row.id === expandContractSectionId ? 'yellow' : 'transparent',
        //     }}
        //     >
        //     {filteredCS.row.name} </p></Tooltip>
        //         );}
        // },

        {
            field: 'description',
            headerName: 'Description',
            description: '',
            sortable: false,
            width: 1000,
            hide: true,
        },
        {
            field: 'status',
            headerName: 'Status',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'hierarchy',
            headerName: 'Hierarchy',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'csfCount',
            headerName: 'csfCount',
            description: '',
            width: 40,
            hide: true
        },
        {
            field: 'cdpCount',
            headerName: 'cdpCount',
            description: '',
            width: 40,
            hide: true
        },
        {
            field: 'createdOn',
            headerName: 'createdOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'createdBy',
            headerName: 'createdBy',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedOn',
            headerName: 'lastModifiedOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedBy',
            headerName: 'lastModifiedBy',
            description: '',
            width: 100,
            hide: true
        },
    ];

    // *************** END COLUMNS *******************************


    // *************** BEGIN TOOLBAR *******************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    {!hideActions &&
                        <GridToolbarExport fontSize="small" />
                    }
                </Box>
            </GridToolbarContainer>
        );
    }

    // *************** END TOOLBAR *******************************

    const getBackgroundColor = (color, mode) =>
        mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

    const getHoverBackgroundColor = (color, mode) =>
        mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);


    // *************** BEGIN MENU *******************************

    function CsGridCrudMenu() {

        const [anchorEl, setAnchorEl] = React.useState(null);

        const isMenuOpen = Boolean(anchorEl);

    const handleCrudMenuOpen = (event) => {
            // dispatchData(changeContractSection({id: rowId}));
            setAnchorEl(event.currentTarget);
        };

        function handleMenuClose()  {
            setAnchorEl(null);
        };



        // ==== begin delete

        const [confirmOpen, setConfirmOpen] = React.useState(false);

        const handleConfirmClose = () => setConfirmOpen(false);

        const handleDelete = () => {
            setConfirmOpen(true);
            setAnchorEl(null);
        };


        const handleConfirmDelete = () => {
            console.log("contract section to be deleted = ", mousedContractSectionId);
            deleteMasterContractSection(mousedContractSectionId)
                .then(() => {
                    console.log("Contract section deleted successfully.");
                    setAnchorEl(null);
                    dispatchData(changeContractSection({csGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    .catch(err => {
            console.log(err)
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Deletion failed"}));
        })
        };
        // console.log("contract to be deleted = ", selectorContractId2);
        // setConfirmOpen(false);
        // };


        // ==== end delete


        const handleMoveUp = () => {
        console.log("moving this cs up: ", mousedContractSectionId);
        moveContractSection(mousedContractSectionId, "Up").then(() => {
            setAnchorEl(null);
            dispatchData(changeContractSection({csGridRefresh: true}));
        })
        };


        const handlePopulateDashboard = () => {
            console.log("populating this dashboard: ", mousedContractSectionId);
            populateDashboard(mousedContractSectionId).then(() => {
                setAnchorEl(null);
                dispatchData(changeContractSection({csGridRefresh: true}));
            })
        };

        const handleMoveDown = () => {
            console.log("moving this cs down: ", mousedContractSectionId)
            moveContractSection(mousedContractSectionId, "Down").then(() => {
                setAnchorEl(null);
                dispatchData(changeContractSection({csGridRefresh: true}));
            })
        };



        const handleMoveIn = () => {
            console.log("moving this cs in: ", mousedContractSectionId)
            moveContractSection(mousedContractSectionId, "In").then(() => {
                setAnchorEl(null);
                dispatchData(changeContractSection({csGridRefresh: true}));
            })
        };

        const handleMoveOut = () => {
            console.log("moving this cs out: ", mousedContractSectionId)
            moveContractSection(mousedContractSectionId, "Out").then(() => {
                setAnchorEl(null);
                dispatchData(changeContractSection({csGridRefresh: true}));
            })
        };


        const handleRepeatBranch = () => {
            console.log("repeating this branch: ", mousedContractSectionId)
            repeatBranch(mousedContractSectionId).then(() => {
                setAnchorEl(null);
                dispatchData(changeContractSection({csGridRefresh: true}));
            })
        };

        const [trimBranchConfirmOpen, setTrimBranchConfirmOpen] = React.useState(false);

        const handleTrimBranchClose = () => setTrimBranchConfirmOpen(false);

        const handleTrimBranch = () => {
            setTrimBranchConfirmOpen(true);
            setAnchorEl(null);
        };


        const handleBuildLineItem = () => {
            dispatchData(changeContractDrilldownCS({QfDrawerState: true }));
            // setAnchorEl(null);
        };


        // const handleTrimBranchConfirmDelete = () => {
        //     console.log("contract section to be deleted = ", mousedContractSectionId);
        //     deleteMasterContractSection(mousedContractSectionId)
        //         .then(() => {
        //             console.log("Contract section deleted successfully.");
        //             setAnchorEl(null);
        //             dispatchData(changeContractSection({csGridRefresh: true}));
        //             dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        //         })
        //         .catch(err => {
        //             console.log(err)
        //             dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Deletion failed"}));
        //         })
        // };

        const handleTrimBranchConfirm = () => {
            console.log("deleting/trimming this branch: ", mousedContractSectionId)
            trimBranch(mousedContractSectionId).then(() => {
                setAnchorEl(null);
                dispatchData(changeContractSection({csGridRefresh: true}));
            })
        };


        const [regrowBranchConfirmOpen, setRegrowBranchConfirmOpen] = React.useState(false);

        const handleRegrowBranchClose = () => setRegrowBranchConfirmOpen(false);

        const handleRegrowBranch = () => {
            setRegrowBranchConfirmOpen(true);
            setAnchorEl(null);
        };


        const handleGraftBranch = () => {
            dispatchData(changeContractSection({
                csGraftingDrawerState: true}));
        };





        // const handleRegrowBranchConfirm = () => {
        //     console.log("regrowing this branch: ", mousedContractSectionId)
        //     regrowBranch(mousedContractSectionId).then(() => {
        //         //
        //         // setAnchorEl(null);
        //         // dispatchData(changeContractSection({csGridRefresh: true}));
        //     updateCsTreeByContractId(mousedContractId).then(() => {
        //         setAnchorEl(null);
        //         dispatchData(changeContractSection({csGridRefresh: true}));
        //     })            })
        // };
        const handleRegrowBranchConfirm = () => {
            console.log("regrowing this branch:", mousedContractSectionId);
            console.log("regrowing this contract:", mousedContractId);

            return regrowBranch(mousedContractSectionId)
                .then(() => {
                    return updateCsTreeByContractId(mousedContractId);
                })
                .then(() => {
                    return updateCsTreeByContractId(mousedContractId);
                })
                .then(() => {
                    return updateCsTreeByContractId(mousedContractId);
                })
                .then(() => {
                    dispatchData(changeContractSection({ csGridRefresh: true }));
                })
                .catch(err => {
                    console.error("Regrow branch failed:", err);
                })
                .finally(() => {
                    setAnchorEl(null);
                });
        };

        // const handleRegrowBranchConfirm = async () => {
        //     console.log("regrowing this branch:", mousedContractSectionId);
        //     console.log("regrowing this contract:", mousedContractId);
        //     try {
        //         await regrowBranch(mousedContractSectionId);
        //         await updateCsTreeByContractId(mousedContractId);
        //         dispatchData(changeContractSection({ csGridRefresh: true }));
        //     } finally {
        //         setAnchorEl(null);
        //     }
        // };

        const [reinsertBranchConfirmOpen, setReinsertBranchConfirmOpen] = React.useState(false);

        const handleReinsertBranchClose = () => setReinsertBranchConfirmOpen(false);

        const handleReinsertBranch = () => {
            setReinsertBranchConfirmOpen(true);
            setAnchorEl(null);
        };

        const handleReinsertBranchConfirm = () => {
            console.log("reinserting the next/trailing branch of this section: ", mousedContractSectionId)
            reinsertBranch(mousedContractSectionId).then(() => {
                setAnchorEl(null);
                dispatchData(changeContractSection({csGridRefresh: true}));
            })
        };


        const handleClone = () => {
            dispatchData(changeContractSection({
                csCloningDrawerState: true}));
        };


        const crudId = 'primary-search-account-menu';

        const renderMenu = (

            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id={crudId}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem
                    onClick={handleEdit}
                >
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Edit Name</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleDelete}>
                    <ListItemIcon>
                        <DeleteOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Delete Section Only</ListItemText>
                </MenuItem>


                <Dialog open={trimBranchConfirmOpen} onClose={handleTrimBranchClose}>
                    <DialogTitle>Confirm Trim Branch</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this contract section and all of its sub-sections? This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleTrimBranchClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleTrimBranchConfirm} color="error">
                            Trim
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={regrowBranchConfirmOpen} onClose={handleRegrowBranchClose}>
                    <DialogTitle>Confirm Regrow Branch</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to add back all trimmed sections under this section?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleRegrowBranchClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleRegrowBranchConfirm} color="error">
                            Regrow
                        </Button>
                    </DialogActions>
                </Dialog>



                <Dialog open={reinsertBranchConfirmOpen} onClose={handleReinsertBranchClose}>
                    <DialogTitle>Confirm Reinsert Branch</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to add back the trimmed branch below this section?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleReinsertBranchClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleReinsertBranchConfirm} color="error">
                            ReInsert
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={confirmOpen} onClose={handleConfirmClose}>
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this contract section? This action cannot be undone.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleConfirmClose} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={handleConfirmDelete} color="error">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

                <MenuItem onClick={handleMoveUp}>
                    <ListItemIcon>
                        <ArrowUpwardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Move Up</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleMoveDown}>
                    <ListItemIcon>
                        <ArrowDownwardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Move Down</ListItemText>
                </MenuItem>
                {selectorContractGridAPI !== "Dashboards" &&
                <MenuItem onClick={handleMoveIn}>
                    <ListItemIcon>
                        <ArrowForwardIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Move In</ListItemText>
                </MenuItem>}
                {selectorContractGridAPI !== "Dashboards" &&
                <MenuItem onClick={handleMoveOut}>
                    <ListItemIcon>
                        <ArrowBackIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Move Out</ListItemText>
                </MenuItem>}
                <MenuItem onClick={handleClone}>
                    <ListItemIcon>
                        <ContentCopyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Clone Contents</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleGraftBranch}>
                    <ListItemIcon>
                        <ReadMoreIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Graft Branch</ListItemText>
                </MenuItem>

                {selectorContractGridAPI !== "Dashboards" &&
                <MenuItem onClick={handleRepeatBranch}>
                    <ListItemIcon>
                        <AccountTree fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Repeat Branch</ListItemText>
                </MenuItem>}

                {selectorContractGridAPI !== "Dashboards" &&
                <MenuItem onClick={handleTrimBranch}>
                    <ListItemIcon>
                        <ContentCut fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Trim Branch</ListItemText>
                </MenuItem>}

                {selectorContractGridAPI !== "Dashboards" &&
                <MenuItem onClick={handleRegrowBranch}>
                    <ListItemIcon>
                        <PolylineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Regrow Branch</ListItemText>
                </MenuItem>}

                {selectorContractGridAPI !== "Dashboards" &&
                <MenuItem onClick={handleReinsertBranch}>
                    <ListItemIcon>
                        <ShareIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>ReInsert Branch</ListItemText>
                </MenuItem>}

                {selectorContractGridAPI === "Dashboards" &&
                <MenuItem onClick={handlePopulateDashboard}>
                    <ListItemIcon>
                        <ContentCopyIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Populate</ListItemText>
                </MenuItem>}


                {/*{selectorContractGridAPI !== "Dashboards" &&*/}
                {/*    <MenuItem onClick={handleBuildLineItem}>*/}
                {/*        <ListItemIcon>*/}
                {/*            <ListIcon fontSize="small" />*/}
                {/*        </ListItemIcon>*/}
                {/*        <ListItemText>Build Line Item</ListItemText>*/}
                {/*    </MenuItem>}*/}


                {/*{selectorContractGridAPI !== "Dashboards" &&*/}
                {/*    <MenuItem onClick={handleHelperPanel}>*/}
                {/*        <ListItemIcon>*/}
                {/*            <HelpIcon fontSize="small" />*/}
                {/*        </ListItemIcon>*/}
                {/*        <ListItemText>Show Helper</ListItemText>*/}
                {/*    </MenuItem>}*/}


                {/*{selectorContractGridAPI !== "Dashboards" &&*/}
                {/*    <MenuItem onClick={handleDynamicHelperPanel}>*/}
                {/*        <ListItemIcon>*/}
                {/*            <HelpIcon fontSize="small" />*/}
                {/*        </ListItemIcon>*/}
                {/*        <ListItemText>Show Dynamic Helper</ListItemText>*/}
                {/*    </MenuItem>}*/}

            </Menu>
        );


        return (
            <div>
                <Tooltip   enterDelay={1000}  enterNextDelay={1000} title={`Action Menu`}>
                <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={crudId}
                    aria-haspopup="true"
                    onClick={handleCrudMenuOpen}
                    color="inherit"
                >
                    <MoreVertIcon  color="primary" fontSize="small"/>
                </IconButton>
                </Tooltip>
                {renderMenu}
            </div>
        );
    }

    // *************** END MENU *******************************




    const handleTree = (callback) => {
        if(treeDepth == 0){
    setTreeDepth(-1)}
        else
        {setTreeDepth(1)};
    console.log("tree depth");
        console.log({treeDepth});
callback(fetchDrilldownCS)};



    const getTreeDataPath = (filteredCS) => filteredCS.hierarchy.split(',');

    const groupingColDef = {
        field: 'name',
        hideDescendantCount: true,
        ml: 1 ,
        '& .level--1': {lm: 0},
        '& .level--2': {lm: 0},
        '& .level--3': {lm: 0},
        '& .level--4': {lm: 0},
        '& .level--5': {lm: 0},
        '& .level--6': {lm: 0},
        '& .level--7': {lm: 0},
        '& .level--8': {lm: 0},
        '& .level--9': {lm: 0},
        '& .level--10': {lm: 0},
        width: 200,
    };



    // ****************** BEGIN RETURN ****************************

    return (

        <Box
        sx={{
            height: 700,
            width: 1,
            '& .level--1': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
            '& .level--2': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
            '& .level--3': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
            '& .level--4': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
            '& .level--5': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
            '& .level--6': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
            '& .level--7': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
            '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
            '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
            '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom


                    }}
        >
            {useSelector((state) => state.contractSectionSlc.value.csDrawerState) &&
                <ContractSectionDrawer
                />}
            {useSelector((state) => state.contractSectionSlc.value.csCloningDrawerState) &&
                <ContractSectionCloningForm
                />}
            {useSelector((state) => state.contractSectionSlc.value.csGraftingDrawerState) &&
            <ContractSectionGraftingForm/>}

    <Stack direction="row" spacing={2}>

            <Box
        >
                {selectorContractGridAPI === "Dashboards" &&
                    <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={"This is the table of contents of the contract.  Click for more information."}>
                    <Typography
                    onClick={() => handleCsInfo()}  style={{cursor:'pointer'}}
                    sx={{ fontWeight: 'bold',
                htmlFontSize: 48
            }} >Dashboards</Typography>
                    </Tooltip>
                    }
                {selectorContractGridAPI !== "Dashboards" &&
                    <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={"This is the list of Dashboards within the dashboard group.  Click for more information."}>
                    <Typography
                    onClick={() => handleCsInfo()}  style={{cursor:'pointer'}}
                    sx={{ fontWeight: 'bold',
                    htmlFontSize: 48
                }} >Contract Sections</Typography>
                    </Tooltip>
                    }
        </Box>
        {!hideActions &&
        <Box              sx={{alignItems: 'bottom',  pb: 0, mr: 3, mb: 0, verticalAlign: 'bottom'}}

                          onClick={() => handleAdd()}>
            <AddCircleOutlineIcon  sx={{my:0 }}  fontSize="medium" color={'primary'}
            />
        </Box>
        }
        <CsInfoDialogue
            open={csInfoOpen}
            onClose={handleCloseCsInfo}
            selectorContractGridAPI={selectorContractGridAPI}
        />
        <Typography sx={{ fontWeight: 'bold',
            htmlFontSize: 48, pl: 4
            // fontsize: 48
        }} >{selectorContractSectionNameShort}</Typography>
    </Stack>
            <handleDeleteOpen/>
            <DataGridPro
                sx={{
                    "& .MuiDataGrid-columnHeader": {
                        display: "none",
                    },
                    }}
                headerHeight={0}
                apiRef={apiRef}
                treeData
                style={{ height: '100% - 20px', width: '100%' }}
                aria-label={"fetchDrilldownCS"}
                rows={filteredCS}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchDrilldownCS)}
                getTreeDataPath={getTreeDataPath}
                groupingColDef={groupingColDef}
                defaultGroupingExpansionDepth = {treeDepth}
                // Control the expanded state with expandedNodes
                // ********************  expand ***********************************************************
                // rowGroupingExpansionModel={expandedNodes}
                // // Handler to toggle expanded nodes
                // onRowGroupingModelChange={(model) => setExpandedNodes(model)}
                // ******************** end expand ***********************************************************
                // defaultGroupingExpansionDepth = {0}
                density={"compact"}
                pageSize={100}
                rowsPerPageOptions={[100]}
                getRowClassName={(filteredCS) => `level--${filteredCS.row.recordLevel}`}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'ordinalNumber', sort: 'asc' }],
                    },
                }}
                components={{
                    Toolbar: CustomToolbar,
                }}
            />
            <QueryFinancialsDrawer/>

        </Box>

    );

    // ****************** END RETURN ****************************

}


